import { useReducer } from 'react';
import { createContext } from 'react';

export const AppContext = createContext("");

const getSessionNumber = (key, fallback) => {
    if (typeof window === 'undefined') return fallback;
    const value = Number(window.sessionStorage.getItem(key));
    return Number.isFinite(value) && value > 0 ? value : fallback;
};

const getSessionBoolean = (key, fallback) => {
    if (typeof window === 'undefined') return fallback;
    const value = window.sessionStorage.getItem(key);
    if (value === 'true') return true;
    if (value === 'false') return false;
    return fallback;
};

const appReducer = (state,action) =>{
    switch (action.type){
        case 'GET_SELECTED_HEADER':
            return state.selectedHeader
        case 'SET_SELECTED_HEADER':
            return {...state,selectedHeader:action.payload}
        case 'GET_SELECTED_SEC_HEADER':
            return state.selectedSecHeader
        case 'SET_SELECTED_SEC_HEADER':
            return {...state,selectedSecHeader:action.payload}
        case 'GET_UPLOADTAB':
            return state.uploadTab
        case 'SET_UPLOADTAB':
            return {...state,uploadTab:action.payload}
        case 'GET_ROLE':
            return state.role
        case 'SET_ROLE':
            return {...state,role:action.payload}
        case 'GET_TOAST':
            return state.isToastDisplayed
        case 'SET_TOAST':
            return {...state,isToastDisplayed:action.payload}
        case 'GET_MERCHANT_FILTERS':
            return state.merchantFilters
        case 'SET_MERCHANT_FILTERS':
            return { ...state, merchantFilters: action.payload }
        case 'GET_OFFER_FILTERS':
            return state.offerFilters
        case 'SET_OFFER_FILTERS':
            return { ...state, offerFilters: action.payload }
        case 'GET_CAMPAIGN_FILTERS':
            return state.camaignFilters
        case 'SET_CAMPAIGN_FILTERS':
            return { ...state, campaignFilters: action.payload }
        case 'SET_OFFERS_PER_PAGE':
            if (typeof window !== 'undefined') {
                window.sessionStorage.setItem('offersPerPage', String(action.payload));
            }
            return { ...state, offersPerPage: action.payload }
        case 'SET_CAMPAIGNS_PER_PAGE':
            if (typeof window !== 'undefined') {
                window.sessionStorage.setItem('campaignsPerPage', String(action.payload));
            }
            return { ...state, campaignsPerPage: action.payload }
        case 'SET_MY_OFFER_TOGGLE':
            if (typeof window !== 'undefined') {
                window.sessionStorage.setItem('myOfferToggle', String(action.payload));
            }
            return { ...state, myOfferToggle: action.payload }
        default:
            return state
    }
}

export const AppContextProvider = ({children}) =>{

    const [state,dispatch] = useReducer(appReducer,{
        selectedHeader:"Offers",
        selectedSecHeader: "Manage Offers",
        uploadTab: "Single Upload",
        role: "",
        isToastDisplayed: false,
        offersPerPage: getSessionNumber('offersPerPage', 10),
        campaignsPerPage: getSessionNumber('campaignsPerPage', 10),
        myOfferToggle: getSessionBoolean('myOfferToggle', false),
        merchantFilters: {
            category: [],
            offerCount: [],
            channel: [],
            country: [],
            lastUpdatedDate: [],
        },
        offerFilters: {
            offerType: [],
            status: [],
            startDate: [],
            endDate: [],
            offerChannel: [],
            offerSource: [],
            merchantName: [],
        },
        campaignFilters: {
            campaignType: [],
            status: [],
            campaignSource: [],
            dateRange: [],
            
        },
    })

    return(
        <AppContext.Provider value={{state,dispatch}}>
            {children}
        </AppContext.Provider>
    )
}